module.exports = __webpack_public_path__ + "img/horizontal_3_1_r_3016.9d42aad2.png";